
import { Modal } from "../../../components";
import { useEventosStore } from "../../../store/eventosStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";

import JsonView from '@uiw/react-json-view';
import JsonViewEditor from '@uiw/react-json-view/editor';
import { lightTheme } from '@uiw/react-json-view/light';
import { darkTheme } from '@uiw/react-json-view/dark';
import { nordTheme } from '@uiw/react-json-view/nord';
import { githubLightTheme } from '@uiw/react-json-view/githubLight';
import { githubDarkTheme } from '@uiw/react-json-view/githubDark';
import { vscodeTheme } from '@uiw/react-json-view/vscode';
import { gruvboxTheme } from '@uiw/react-json-view/gruvbox';
import { monokaiTheme } from '@uiw/react-json-view/monokai';
import { basicTheme } from '@uiw/react-json-view/basic';

import { TriangleArrow } from '@uiw/react-json-view/triangle-arrow';
import { TriangleSolidArrow } from '@uiw/react-json-view/triangle-solid-arrow';
import BadgeEvento from "../../../components/BadgeEvento";
import HeaderEvento from "../../../components/HeaderEvento";
import Causer from "./components/Causer";
import Properties from "./components/Properties";


const ModalDetalleEvento = () => {
    const { modals, handlerModal } = useGeneralAppStore()
    const { detalleEvent } = useEventosStore();

    return (
        <>
            <Modal
                show={modals.includes('detalle-evento')}
                size="xl"
                onHide={() => handlerModal({ modal: false, modalName: "detalle-evento" })}
                title={() => "Detalle del evento"}
            >
                <section className="w-100 d-flex flex-column gap-4">
                    <div className="d-flex align-items-center gap-4">
                        <h4 className="m-0">ID:<span className="text-dark fw-medium">{detalleEvent.id}</span></h4>
                        <h5 className="m-0 ps-4" style={{ borderLeft: "2px solid black" }}>Tipo: <BadgeEvento name={detalleEvent.log_name} /></h5>
                    </div>


                    <HeaderEvento log_name={detalleEvent.log_name} evento={detalleEvent.event} size={'lg'} descripcion={detalleEvent.description} created={detalleEvent.created_at} />
                    {
                        detalleEvent.causer &&
                        <Causer causer={detalleEvent.causer} />
                    }
                    {
                        detalleEvent.log_name == 'error'
                            ?
                            <JsonView
                                value={detalleEvent.properties}
                                style={vscodeTheme}
                                editable={false}
                                shortenTextAfterLength={0}

                            />
                            :
                            <>
                                <Properties properties={detalleEvent.properties} />
                                <JsonView
                                    value={detalleEvent.subject}
                                    editable={false}
                                    style={vscodeTheme}
                                    shortenTextAfterLength={0}
                                // displayObjectSize={false}
                                // displayDataTypes={false}
                                />
                            </>
                    }


                </section>


            </Modal>
        </>
    );
}
export default ModalDetalleEvento;